'use strict';

UserConversationsController.$inject = [
  'currentUser',
];

export function UserConversationsController(
  currentUser,
) {
}



// WEBPACK FOOTER //
// ./src/js/comments/controllers/UserConversationsController.js